module.exports = __webpack_public_path__ + "static/media/SVS_UpperLogo.72d756da.png";